import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../../utils/axios';

export const verifyTrn = async ({ company_name, trn_no }) => {
  const { data } = await apiClient.post('/trn/verify', { company_name, trn_no }, { skipErrorSnackbar: true });
  return data;
};

export const useVerifyTrnHandler = () =>
  useMutation({
    mutationFn: verifyTrn,
  });

/** Upstream returns strings like "True" or "False (Company name mismatch in modal)". */
export const isTrnNameMatched = (nameMatched) => {
  const value = String(nameMatched ?? '')
    .trim()
    .toLowerCase();
  return value.startsWith('true');
};

export const resolveTrnRegistryNames = (response) => {
  const names = Array.isArray(response?.full_company_name) ? response.full_company_name.filter(Boolean) : [];
  if (names.length) return names;
  if (response?.trn_company_name) return [response.trn_company_name];
  return [];
};
